const AI_SUGGESTION_TYPES = {
  BUTTON: 'button',
  PROMPT: 'prompt',
} as const;

export default AI_SUGGESTION_TYPES;
